import React, { useState, useCallback, useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Handle, Position, useNodeId, useReactFlow } from "reactflow";
import { Input, Tag, Tooltip, Button } from "antd";
import ContextMenu from "./ContextMenu";
import {
  ApartmentOutlined,
  EditOutlined,
  LinkOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import "./FlowNode.css";

function FlowNode({ data, isConnectable }) {
  console.log("flow", data);
  const nodeId = useNodeId();
  const [flowName, setFlowName] = useState(data?.testName || "Unnamed Flow");
  const [parents, setParents] = useState(data?.parents || []);
  const [isEditingName, setIsEditingName] = useState(false);
  const [isContextMenuVisible, setIsContextMenuVisible] = useState(false);
  const nodeRef = useRef(null);
  const [contextMenuPosition, setContextMenuPosition] = useState({
    x: 0,
    y: 0,
  });
  const reactFlowInstance = useReactFlow();
  const userRole = localStorage.getItem("userRole");
  const userName = localStorage.getItem("userName");
  const job_details = useLocation();
  const [isExpanded, setIsExpanded] = useState(data["selected"] ? true : false);
  const [moduloNodeId, setModuloNodeId] = useState(
    data["moduloID"] ? data["moduloID"] : 0
  );

  const [testingInstruction, setTestingInstruction] = useState(
    data["testingInstruction"] ? data["testingInstruction"] : ""
  );
  const [startDate, setStartDate] = useState(
    data["startDate"]
      ? new Date(data["startDate"]).toISOString().split("T")[0]
      : null
  );
  const [endDate, setEndDate] = useState(
    data["endDate"]
      ? new Date(data["endDate"]).toISOString().split("T")[0]
      : null
  );
  const [testDuration, setTestDuration] = useState(
    data["testDuration"] !== undefined &&
      data["testDuration"] !== null &&
      data["testDuration"] !== -1
      ? data["testDuration"]
      : ""
  );
  const [expenseEstimation, setExpenseEstimation] = useState(
    data["expenseEstimation"] !== undefined &&
      data["expenseEstimation"] !== null &&
      data["expenseEstimation"] !== -1
      ? data["expenseEstimation"]
      : ""
  );
  const [hoursEstimation, setHoursEstimation] = useState(
    data["hoursEstimation"] !== undefined &&
      data["hoursEstimation"] !== null &&
      data["hoursEstimation"] !== -1
      ? data["hoursEstimation"]
      : ""
  );

  const [fixture, setFixture] = useState(
    data["fixture"] ? data["fixture"] : ""
  );
  // console.log("hehe:" , data);
  // useEffect(() => {
  //   console.log('hoursEstimation is:', hoursEstimation);
  // }, [hoursEstimation]);

  // console.log(data["hoursEstimation"] === '' || data["hoursEstimation"] === 0);
  const [fixtures, setFixtures] = useState([]);
  const [totalUsedQuantity, setTotalUsedQuantity] = useState(0);

  const [climaticChamber, setClimaticChamber] = useState(
    data["climaticChamber"] ? data["climaticChamber"] : ""
  );
  const [climaticChambers, setClimaticChambers] = useState([]);
  const [status, setStatus] = useState(
    data["status"] ? data["status"] : "Test Not Planned"
  );
  const [linkCopied, setLinkCopied] = useState(false);
  const [TIRNum, setTIRNum] = useState(data["TIRNum"] ? data["TIRNum"] : "");
  const [sampleSizeNote, setSampleSizeNote] = useState(
    data["sampleSizeNote"] ? data["sampleSizeNote"] : ""
  );

  const [pdName, setPdName] = useState(data["PDName"] ? data["PDName"] : "");

  data["sampleSizeNote"] = sampleSizeNote;
  data["testingInstruction"] = testingInstruction;
  data["startDate"] = startDate;
  data["endDate"] = endDate;
  data["testDuration"] = testDuration;
  data["expenseEstimation"] = expenseEstimation;
  data["hoursEstimation"] = hoursEstimation;
  data["fixture"] = fixture;
  data["climaticChamber"] = climaticChamber;
  data["status"] = status;
  data["TIRNum"] = TIRNum;
  data["PDName"] = pdName;
  data["samplesUsed"] = totalUsedQuantity;
  data["testName"] = flowName;
  const testStatuses = [
    "Test Not Started",
    "In Progress Without Incident",
    "Completed Without Incident",
    "In Progress With Incident",
    "Completed With Incident",
  ];

  const tableRef = useRef(null);
  const fileInputRef = useRef(null);

  // For Test Results
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [logData, setLogData] = useState([]);

  //For Test Reports
  const [isLoadingReport, setIsLoadingReport] = useState(false);
  const [isReportModalVisible, setReportIsModalVisible] = useState(false);
  const [reportLogData, setReportLogData] = useState([]);

  //For Test Report Uploads
  const [isUploadingReport, setIsUploadingReport] = useState(false);
  const [isApprovedUpload, setIsApprovedUpload] = useState(true);

  // For Sample Selection
  const [isSampleModalVisible, setIsSampleModalVisible] = useState(false);
  const [sampleData, setSampleData] = useState([]);

  //For Data Table
  const [hover, setHover] = useState(false);

  // Update data object when values change
  data.flowName = flowName;
  data.parents = parents;

  const handleFlowNameChange = useCallback((e) => {
    setFlowName(e.target.value);
  }, []);

  const handleContextMenu = (event) => {
    event.preventDefault();
    // console.log('Context menu event:', event);
    setContextMenuPosition({ x: event.pageX, y: event.pageY });
    // console.log('Setting context menu position to:', { x: event.pageX, y: event.pageY });
    setIsContextMenuVisible(true);
    // console.log('Context menu visibility set to true');
  };

  const handleDeleteNode = () => {
    console.log("Deleting node:", nodeId);
    reactFlowInstance.setNodes((nds) =>
      nds.filter((node) => node.id !== nodeId)
    );
  };

  const handleDownloadNode = (e) => {
    // if (e) e.preventDefault();
  };

  const handleClick = () => {
    // console.log('Click detected, hiding context menu');
    setIsContextMenuVisible(false);
  };

  useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  return (
    <div
      className={
        isExpanded ? "text-updater-node-expanded" : "text-updater-node"
      }
      onContextMenu={handleContextMenu}
    >
      <div className="flow-declaration-node">
        <Handle
          type="target"
          position={Position.Top}
          isConnectable={isConnectable}
        />
        {isContextMenuVisible && (
          <div
            ref={nodeRef}
            className="context-menu"
            style={{
              backgroundColor: "white",
              border: "1px solid black",
              zIndex: 1000,
            }}
          >
            <ContextMenu
              onDelete={handleDeleteNode}
              onDownload={handleDownloadNode}
              enableDownload={false}
            />
            {console.log("Context menu rendered")}
          </div>
        )}

        <div className="flow-header">
          <ApartmentOutlined className="flow-icon" />
          {isEditingName ? (
            <>
              <Input
                id="flowName"
                placeholder="Enter flow name"
                value={flowName}
                onChange={handleFlowNameChange}
                className="nodrag"
              />
            </>
          ) : (
            <>
              <span className="flow-label">{flowName}</span>
            </>
          )}
          {isEditingName ? (
            <Button
              type="text"
              disabled={flowName === ""}
              icon={<SaveOutlined />}
              style={{ marginTop: 15 }}
              className="flow-icon"
              onClick={() => {
                setFlowName(flowName);
                setIsEditingName(false);
              }}
            />
          ) : (
            <Button
              type="text"
              icon={<EditOutlined />}
              className="flow-icon"
              style={{ marginTop: 15 }}
              onClick={() => {
                setIsEditingName(true);
              }}
            />
          )}
        </div>

        <Handle
          type="source"
          position={Position.Bottom}
          isConnectable={isConnectable}
        />
      </div>
    </div>
  );
}

export default FlowNode;
